




















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import { EmojiHelper } from './helpers/emoji.helper';
import { IEmoji } from './types/Emoji';

@Component
export default class InlineEmoji extends Vue {
  @Prop() matchedEmojis: IEmoji[];
  @Prop() skinTone: number;
  @Prop() selected: number;

  @Watch('selected')
  watchSelected() {
    const emojiRow: HTMLElement = document.getElementById(
      this.matchedEmojis?.length && this.matchedEmojis[this.selected]?.id
    );
    if (emojiRow) {
      emojiRow.scrollIntoView({ block: 'nearest' });
    }
  }

  getEmoji(emoji): string {
    return EmojiHelper.getEmojiWithSkinTone(emoji, this.skinTone).native;
  }

  select(emoji: IEmoji) {
    this.$emit('select', emoji);
  }
}
